import { useStaticQuery, graphql } from 'gatsby';

const featureQuery = () => {
    const data = useStaticQuery(graphql`
        query FeatureQuery {
            contentfulFeatureProducts {
                featureList {
                    category {
                        url
                    }
                    name
                    url
                    images {
                        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 250, formats: [WEBP], breakpoints: [125, 250, 375])
                    }
                }
            }
        }
    `);

    return data.contentfulFeatureProducts.featureList;
};

export default featureQuery;
